/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { Tag } from 'primereact/tag';
import { useTranslation } from 'react-i18next';
import { useStoreContext } from '@/contexts/StoreContext';
import { classNames } from 'primereact/utils';

interface UserGroupsBannerProps {
  className?: string;
}
export const UserGroupsBanner: React.FC<UserGroupsBannerProps> = ({ className }) => {
  const { t } = useTranslation();
  const { currentUser } = useStoreContext();

  if (!currentUser?.groups || currentUser.groups.length === 0) {
    return null;
  }

  return (
    <div className={classNames(className, 'flex flex-column gap-2')}>
      <span className="text-sm font-medium text-color-secondary">
        <i className="pi pi-users mr-2" />
        {t(['launchers.your_groups', 'Your groups'])}
      </span>
      <div className="flex flex-wrap gap-1">
        {currentUser.groups.map((group, idx) => (
          <Tag key={idx} value={group} />
        ))}
      </div>
    </div>
  );
};
